<script setup lang="ts">
import { startUnreadNotificationPush } from "./utils/unreadNotificationPush";

startUnreadNotificationPush()
</script>

<template>
<router-view></router-view>
</template>

<style scoped>
</style>
